import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const NotAllowedChannelButtonContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: ${Screen.widthRatio * 700}px;
  left: ${Screen.widthRatio * 780}px;
`;

export default NotAllowedChannelButtonContainer;
